import { useContext, useEffect } from "react";
import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { defaultConfig } from "./default_config";
import { PivotControl } from "../../constants/pivot_control_options";
import { paramsToTransformArgs } from "./params_to_transform_args";
import { getPurchasingCalendarTableData } from "../../utils/purchasing_calendar_table_utils";
import { PurchasingCalendarEditsContext } from "../../contexts/purchasing_calendar_edits";

export const PurchasingCalendarContainer = () => {
  const {
    deliveryDateEdits,
    setDeliveryDateEdits,
    editMode,
  } = useContext(PurchasingCalendarEditsContext);

  useEffect(() => {
    return () => {
      setDeliveryDateEdits({});
    };
  }, [setDeliveryDateEdits]);

  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "purchasing_calendar",
        transformId: "purchasing_calendar_editable",
        folder: "outputs",
        title: "Purchasing Calendar",
        dateHierarchyColumnFilter: null,
        excludedSegmentationsFilter: [
          "order_id",
          "inventory_id",
          "base_color",
          "edited_by",
          "edited_at",
          "is_edited_any",
          "days",
          "type",
          "date",
        ],
        additionalSegmentationColumns: [
          { name: "default_lead_time_bucket_days", caption: "Lead Time Bucket (days)" },
        ],
        measureColumnFilter: null,
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.DatePeriodPicker,
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
          PivotControl.Download,
          PivotControl.EditModeToggle,
        ],
        columnHeaderMap: {
          planning_cycle: "Planning Cycle",
          order_date: "Order Date",
          supplier: "Supplier",
          location: "Location",
          sku: "SKU",
          default_lead_time_bucket_days_min: "Default Lead Time",
          delivery_date: "Delivery Date",
          calculated_lead_time: "Lead Time (days)",
          days_change_vs_default: "Days Change",
        },
        paramsToTransformArgs: paramsToTransformArgs,
        purchasingCalendarConfig: {
          deliveryDateEdits,
          setDeliveryDateEdits,
          editMode: editMode,
        },
        getMatrix: getPurchasingCalendarTableData,
      }}
      defaultConfig={defaultConfig}
    />
  );
};
